document.addEventListener( 'DOMContentLoaded', function () {
	let slickContainer = jQuery(' .content-slider ');
	if( typeof slickContainer.slick === 'function' ) {
		slickContainer.slick( {
			dots: false,
			infinite: false,
			arrows: false,
			slidesToScroll: 1,
			variableWidth: true,
			swipe: true,
			draggable: true,
			speed: 300,
			swipeToSlide: true,
			centerMode: false,
		} );
	}
} );
